import React from 'react'
import PropTypes from 'prop-types'
import EditUserListItem from './EditUserListItem'
import css from './Users.css'

function EditUserColumns({ dso, toggleEditModal, users }) {
  const noSuperAdmins = users.filter(user => !user.roles.some(role => role.name === 'super_admin'))

  const practiceAdmins = noSuperAdmins
    .filter(user => user.roles.some(role => role.name === 'practice_admin'))
    .map(user => ({ ...user, type: 'practice_admin' }))

  const locationAdmins = noSuperAdmins
    .filter(user => user.roles.some(role => role.name === 'location_admin'))
    .map(user => ({ ...user, type: 'location_admin' }))


  return (
    <div className={css.usersContainer}>
      <div className={css.usersColumn}>
        <h3>Practice Admins </h3>
        <ul>
          {practiceAdmins.map(user => (
            <EditUserListItem
              key={user.id}
              toggleEditModal={toggleEditModal}
              user={user}
            />
          ))}
        </ul>
      </div>
      {dso && (
        <div className={css.usersColumn}>
          <h3>Location Admins </h3>
          <ul>
            {locationAdmins.map(user => (
              <EditUserListItem
                key={user.id}
                toggleEditModal={toggleEditModal}
                user={user}
              />
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

EditUserColumns.propTypes = {
  dso: PropTypes.bool.isRequired,
  toggleEditModal: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    email: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    roles: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      resource_id: PropTypes.number,
      resource_type: PropTypes.string,
    })).isRequired,
  })).isRequired,
}

export default EditUserColumns



// WEBPACK FOOTER //
// ./src/AddPractice/Users/EditUserColumns.js